import React from "react";

interface LogoProps {
  size?: "small" | "medium" | "large";
  className?: string;
  onClick?: () => void;
}

const Logo: React.FC<LogoProps> = ({ size = "medium", className = "", onClick }) => {
  const sizeClasses = {
    small: "logo-small",
    medium: "logo-medium",
    large: "logo-large"
  };

  return (
    <div
      className={`agk-logo ${sizeClasses[size]} ${className}`}
      onClick={onClick}
    >
      <div className="logo-container">
        <span className="logo-agk">EDGE KEY</span>
      </div>
    </div>
  );
};

export default Logo;